package one.healthium.intercom

import one.healthium.domain.user.UserModel
import one.primehealth.app.BaseAppConfig

actual object IntercomPlatform {
    private lateinit var baseAppConfig: BaseAppConfig

    fun init(baseAppConfig: BaseAppConfig) {
        this.baseAppConfig = baseAppConfig
    }

    actual suspend fun boot() {
        val props = js("({})").unsafeCast<dynamic>()
        props["app_id"] = baseAppConfig.intercomAppKey
        props["hide_default_launcher"] = true
        props["alignment"] = "center"
        IntercomSdk.init(props)
    }

    actual suspend fun present(user: UserModel) {
        val userAttributes = buildAttributesMap(user, baseAppConfig).let { attrs ->
            val props = js("({})").unsafeCast<dynamic>()
            props["user_id"] = user.id
            props["name"] = user.profile.name
            props["email"] = user.profile.email
            attrs.forEach { (key, value) ->
                props[key] = value
            }
            props
        }
        IntercomSdk.update(userAttributes)
        IntercomSdk.show()
    }

    actual suspend fun shutdown() {
        IntercomSdk.shutdown()
    }
}